module.exports = __webpack_public_path__ + "img/crotch height.c729194e.png";